import { path } from "d3-path";

const constant = x => () => x;

export default function() {
  let source = d => d.source;
  let target = d => d.target;
  let x = d => d.x;
  let y0 = d => d.y0;
  let y1 = d => d.y1;
  let context = null;

  function ribbon() {
    let buffer;
    let argv = Array.prototype.slice.call(arguments);
    let s = source.apply(this, argv);
    let t = target.apply(this, argv);
    let sx = +x.apply(this, ((argv[0] = s), argv));
    let sy0 = y0.apply(this, argv);
    let sy1 = y1.apply(this, argv);
    let tx = +x.apply(this, ((argv[0] = t), argv));
    let ty0 = y0.apply(this, argv);
    let ty1 = y1.apply(this, argv);

    if (!context) context = buffer = path();

    let s0 = [sx, sy0];
    let s1 = [sx, sy1];
    let t0 = [tx, ty0];
    let t1 = [tx, ty1];

    let r = (sx + tx) / 2;

    context.moveTo(s0[0], s0[1]);
    context.lineTo(s1[0], s1[1]);

    let s1c = [r, sy1];
    let t1c = [r, ty1];
    context.bezierCurveTo(s1c[0], s1c[1], t1c[0], t1c[1], t1[0], t1[1]);

    context.lineTo(t0[0], t0[1]);

    let t0c = [r, ty0];
    let s0c = [r, sy0];
    context.bezierCurveTo(t0c[0], t0c[1], s0c[0], s0c[1], s0[0], s0[1]);

    context.closePath();

    if (buffer) return (context = null), buffer + "" || null;
  }

  ribbon.x = function(_) {
    return arguments.length
      ? ((x = typeof _ === "function" ? _ : constant(+_)), ribbon)
      : x;
  };

  ribbon.y0 = function(_) {
    return arguments.length
      ? ((y0 = typeof _ === "function" ? _ : constant(+_)), ribbon)
      : y0;
  };

  ribbon.y1 = function(_) {
    return arguments.length
      ? ((y1 = typeof _ === "function" ? _ : constant(+_)), ribbon)
      : y1;
  };

  ribbon.source = function(_) {
    return arguments.length ? ((source = _), ribbon) : source;
  };

  ribbon.target = function(_) {
    return arguments.length ? ((target = _), ribbon) : target;
  };

  ribbon.context = function(_) {
    return arguments.length
      ? ((context = _ == null ? null : _), ribbon)
      : context;
  };

  return ribbon;
}
